<template>
  <div class="home">
    <Menu></Menu>
    <div v-show="showList">
      <h2>ACSW Dog Registry</h2>
      <keep-alive>
      <DogTbl :dogs="dogs"
              v-show="!fullEditInProcess"
        @beginFullEdit="toggleEditOn"
        @beginTitleEdit="toggleTitleOn"/>
      </keep-alive>
    </div>
    <DogEdit
        :dog="currDog"
        :mbr="currDog.Member"
        :dogs="dogs"
        :allow-owner-change="true"
        v-show="fullEditInProcess"
        @endFullEdit="toggleEditOff"
        @endDogEdit="toggleEditOff">
    </DogEdit>
    <title-edit
        :dog="currDog"
        :mbr="currDog.Member"
        v-show="titleEditInProcess"
        @endTitleEdit="toggleTitleOff">

    </title-edit>
  </div>
</template>

<script>
// @ is an alias to /src
import DogTbl from '@/components/DogTbl.vue'
import DogEdit from '@/components/DogEdit.vue'
import TitleEdit from '@/components/TitleEdit.vue'
import Menu from '@/components/Menu.vue'

export default {
  name: 'Dogs',
  components: {
    DogTbl,
    DogEdit,
    TitleEdit,
    Menu
  },
  mounted: function () {
    console.log('Dogs mounted')
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadDogs()
    this.fullEditInProcess = true
    this.fullEditInProcess = false
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      console.log(isVisible)
      console.log(entry)
    },
    toggleTitleOn: function (item) {
      console.log(item)

      this.editedIndex = this.dogs.indexOf(item)
      this.currDog={}
      this.currDog = JSON.parse(JSON.stringify(item))
      this.titleEditInProcess = true
    },
    toggleTitleOff: function (item) {
      this.titleEditInProcess = false
      if(item) {
        console.log(item)
        this.dogs.splice(this.editedIndex,1,item)
        this.currDog = item
      }
    },
    toggleEditOn: function (item) {
      console.log(item)

      this.editedIndex = this.dogs.indexOf(item)
      this.currDog={}
      this.currDog = JSON.parse(JSON.stringify(item))
      this.fullEditInProcess = true
    },
    toggleEditOff: function (item) {
      this.fullEditInProcess = false
      if(item) {
        console.log(item)
        this.dogs.splice(this.editedIndex,1,item)
      }
      this.loadDogs()
    },
    loadDogs: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/dogs', {
        token: theToken
      })
          .then(response => {
            this.dogs = response.data.dogs
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
            console.log(this.dogs)
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    }
  },
  computed: {
    showList: function () {
      console.log("called showList()")
      if(this.fullEdit || this.titleEditInProcess){
        return false
      }
      if (this.$usrStore.token) {
        return this.$hasRole(['adm','sys'])
      } else {
        return false
      }
    },
    fullEdit: function () {
      return this.fullEditInProcess
    }
  },
  data: () => ({
    loading: false,
    fullEditInProcess: false,
    titleEditInProcess: false,
    currDog: {},
    dogs: []
  })
}
</script>
